import { render, staticRenderFns } from "./AboutThumb.vue?vue&type=template&id=1c2bb1df&scoped=true&"
import script from "./AboutThumb.vue?vue&type=script&lang=js&"
export * from "./AboutThumb.vue?vue&type=script&lang=js&"
import style0 from "./AboutThumb.vue?vue&type=style&index=0&id=1c2bb1df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2bb1df",
  null
  
)

export default component.exports